module.exports = __webpack_public_path__ + "static/soundline-logo-black-95344104d11f9335c71c0ff9f17395c6.png";